import React from "react";

const personalInfoContent = [
  { meta: "Role", metaInfo: "React Developer" },
  { meta: "Location", metaInfo: "Hamburg" },
  { meta: "Nationality", metaInfo: "German" },
  { meta: "Experience", metaInfo: "5+ years" },
  { meta: "Availability", metaInfo: "Selective" },
  { meta: "Email", metaInfo: "contact@bbacim.com" },
  { meta: "Languages", metaInfo: "German, English, French, Arabic, Spanish" },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span
            className={`value ${val.meta === "Email" ? "value-email" : ""}`.trim()}
          >
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
